import React from "react";

const formatText = (text) => {
  return text.split("\n").map((line, index) => (
    <React.Fragment key={index}>
      {line}
      {index < text.split("\n").length - 1 && <br />}
    </React.Fragment>
  ));
};

const IntroText = ({ title, desc, extra }) => {
  return (
    <div className="mb-7">
      <p className="text-3xl font-semibold mb-2.5">{formatText(title)}</p>
      {desc && (
        <p className="mb-3 text-lg font-medium text-neutral-400">
          {formatText(desc)}
        </p>
      )}
      {extra && (
        <p className="text-sm text-neutral-400 break-keep">
          {formatText(extra)}
        </p>
      )}
    </div>
  );
};

export default IntroText;
